import { addDays, format } from "date-fns";
var formate = "yyyy-MM-dd HH:mm:ss";
export const events = [
  // {
  //   id: 20000000,
  //   name: "Hang out",
  //   location: "3115 171 PL SE WA 98012",
  //   locationType: "In Person Meeting",
  //   desc: "We will play video games and XBOX. Come early so that we can set up everything and other things. Other than that have Fun!",
  //   color: "red",
  //   link: "meetup",
  //   start: format(addDays(new Date(), 0), formate),
  //   end: format(addDays(new Date(), 20), formate),
  //   length: 30,
  // },
  // {
  //   id: 20121212,
  //   name: "Elevated Sportz meetup",
  //   locationType: "In Person Meeting",
  //   location: "Eleveated Sports",
  //   desc: "We will play video games and XBOX. Come early so that we can set up everything and other things. Other than that have Fun!",
  //   color: "green",
  //   link: "esportz",
  //   start: format(addDays(new Date(), 0), formate),
  //   end: format(addDays(new Date(), 20), formate),
  //   length: 47,
  // },
];
export function addEvent(event) {
  events.push(event);
}
